
import api from '@/api';
import CompanyDetailsView from '@/components/CompanyDetailsView.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import { mainStore } from '@/store';
import { retencaoFinanceiraStore, userActionStore } from '@/utils/store-accessor';
import _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import ListFinanceiro from './ListFinanceiro.vue';
import ListMessageSyngoo from './ListMessageSyngoo.vue';
import ListSendMessages from './ListSendMessages.vue';
import ListTitulosPagosAposVencimento from './ListTitulosPagosAposVencimento.vue';
import RelatorioOcorrencias from './RelatorioOcorrencias.vue';

@Component({
  components: {
    ShowPopup,
    CompanyDetailsView,
    ListFinanceiro,
    ListSendMessages,
    ListMessageSyngoo,
    ListTitulosPagosAposVencimento,
    RelatorioOcorrencias,
  },
})
export default class Dashboard extends Vue {
  @Watch('propState', { immediate: true, deep: true })
  async getSolicitacoes() {
    // if (this.propState > 0) {
    //   this.unidades_retencao_livros = await gestaoAdministrativaStore.getCompaniesGestaoAdministrativa();
    // }
  }

  public isLoading = false;
  public propState = 0;
  public itemUnidade = [];
  public unidades_retencao = [];
  public propId = 0;
  public c014Unidade = 0;
  public unidadeGestaoAdm = 0;
  public filtroAdimplente = 0;
  public filtroGestao = 1;
  public deveDesde = 0;
  public statusCobranca = [];
  public tipoTitulo = [];

  public tipoUnidade = 1;

  public currentTab = 0;

  get headerGeralUnidade() {
    if (this.currentUser.franchising_id === 1) {
      return this.headerGeral;
    } else {
      return this.headerGeralPhenom;
    }
  }

  public headerGeral = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'center',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'center',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'center',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'KNN',
      sortable: true,
      value: 'valor_em_atraso_knn_brasil',
      align: 'left',
    },
    {
      text: 'Fundo',
      sortable: true,
      value: 'valor_em_atraso_fundo_de_prop',
      align: 'left',
    },
    {
      text: 'PF',
      sortable: true,
      value: 'valor_em_atraso_pf',
      align: 'left',
    },
    {
      text: 'Total',
      sortable: true,
      value: 'total',
      align: 'left',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: 'created_by_name',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerGeralPhenom = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'PHENOM',
      sortable: true,
      value: 'valor_em_atraso_knn_brasil',
      align: 'left',
    },
    {
      text: 'Fundo',
      sortable: true,
      value: 'valor_em_atraso_fundo_de_prop',
      align: 'left',
    },
    {
      text: 'PF',
      sortable: true,
      value: 'valor_em_atraso_pf',
      align: 'left',
    },
    {
      text: 'Total',
      sortable: true,
      value: 'total',
      align: 'left',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: 'created_by_name',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerLivros = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_livro',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_livro',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: 'created_by_name',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerRenegociacao = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_reneg',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_reneg',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: 'created_by_name',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerTaxaFranquia = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_taxa_franquia',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_taxa_franquia',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: '',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerFundo = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_fundo',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_fundo',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: '',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerMutuo = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_mutuo',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_mutuo',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: '',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  public headerMKT = [
    // {
    //   text: "c014",
    //   sortable: false,
    //   value: "c014_id",
    //   align: "left",
    // },
    {
      text: 'Unidade',
      sortable: false,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: false,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: false,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'center',
    },
    {
      text: 'Venda PF',
      sortable: true,
      value: 'allow_invoice_aluno',
      align: 'center',
    },
    {
      text: 'Venda PJ',
      sortable: true,
      value: 'allow_invoice_company',
      align: 'center',
    },
    {
      text: 'Inaugurada',
      sortable: true,
      value: 'inaugurada',
      align: 'center',
    },
    {
      text: 'Valor Vencido',
      sortable: true,
      value: 'valor_atraso_mkt',
      align: 'center',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'dias_devendo_mkt',
      align: 'center',
    },
    {
      text: 'Status Cobrança',
      sortable: false,
      value: 'status_cobranca',
      align: 'center',
    },
    // {
    //   text: "Adimplência",
    //   sortable: false,
    //   value: "situacao_financeiro",
    //   align: "center",
    // },
    {
      text: 'Data Próxima Cobrança',
      sortable: true,
      value: 'proximo_contato',
      align: 'center',
    },
    {
      text: 'Responsável',
      sortable: false,
      value: '',
      align: 'center',
    },
    // {
    //   text: "Ações",
    //   sortable: false,
    //   value: "actions",
    //   align: "center",
    // },
  ];

  get devendoItems() {
    return [
      {
        id: 0,
        descricao: 'Todas',
      },
      {
        id: 1,
        descricao: 'até 30 Dias',
      },
      {
        id: 2,
        descricao: '30 a 60 Dias',
      },
      {
        id: 3,
        descricao: '60 a 90 Dias',
      },
      {
        id: 4,
        descricao: '+ 90 Dias',
      },
    ];
  }

  get unidadeItems() {
    return [
      {
        id: 1,
        descricao: 'Ativa',
      },
      {
        id: 2,
        descricao: 'Inativa',
      },
    ];
  }

  get itemsStatus() {
    return [
      // {
      //   id: 0,
      //   descricao: "Todas",
      // },
      {
        id: 1,
        descricao: 'Liberada',
      },
      {
        id: 2,
        descricao: 'Pedido liberado',
      },
      {
        id: 3,
        descricao: 'Bloqueada',
      },
    ];
  }

  get filtroAdimplenteItems() {
    return [
      {
        id: 0,
        descricao: 'Todas',
      },
      {
        id: 1,
        descricao: 'Adimplente',
      },
      {
        id: 2,
        descricao: 'Inadimplente',
      },
    ];
  }

  get statusUnidadesItems() {
    return [
      {
        id: 0,
        descricao: 'Todas',
      },
      {
        id: 1,
        descricao: 'Ativo',
      },
      {
        id: 2,
        descricao: 'Inativo',
      },
    ];
  }

  get allItemsAdimplentes() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo == 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo >= 1 && f.dias_devendo <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo >= 31 && f.dias_devendo <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo >= 61 && f.dias_devendo <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsGeral() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo >= 1 && f.dias_devendo <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo >= 31 && f.dias_devendo <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo >= 61 && f.dias_devendo <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsLivros() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_livro > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_livro >= 1 && f.dias_devendo_livro <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_livro >= 31 && f.dias_devendo_livro <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_livro >= 61 && f.dias_devendo_livro <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_livro >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsRenegociacao() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_reneg > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_reneg >= 1 && f.dias_devendo_reneg <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_reneg >= 31 && f.dias_devendo_reneg <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_reneg >= 61 && f.dias_devendo_reneg <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_reneg >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsTaxaFranquia() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_taxa_franquia > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_taxa_franquia >= 1 && f.dias_devendo_taxa_franquia <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_taxa_franquia >= 31 && f.dias_devendo_taxa_franquia <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_taxa_franquia >= 61 && f.dias_devendo_taxa_franquia <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_taxa_franquia >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsMutuo() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_mutuo > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_mutuo >= 1 && f.dias_devendo_mutuo <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_mutuo >= 31 && f.dias_devendo_mutuo <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_mutuo >= 61 && f.dias_devendo_mutuo <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_mutuo >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsFundo() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_fundo > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_fundo >= 1 && f.dias_devendo_fundo <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_fundo >= 31 && f.dias_devendo_fundo <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_fundo >= 61 && f.dias_devendo_fundo <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_fundo >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsLivrosVendaDireta() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.allow_invoice_aluno === 'SIM');

    item = item.filter((f) => f.dias_devendo_livro > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_livro >= 1 && f.dias_devendo_livro <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_livro >= 31 && f.dias_devendo_livro <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_livro >= 61 && f.dias_devendo_livro <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_livro >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  get allItemsMKT() {
    let item = this.unidades_retencao;

    item = item.filter((f) => f.dias_devendo_mkt > 0);

    if (this.deveDesde === 1) {
      item = item.filter((f) => f.dias_devendo_mkt >= 1 && f.dias_devendo_mkt <= 30);
    }
    if (this.deveDesde === 2) {
      item = item.filter((f) => f.dias_devendo_mkt >= 31 && f.dias_devendo_mkt <= 60);
    }
    if (this.deveDesde === 3) {
      item = item.filter((f) => f.dias_devendo_mkt >= 61 && f.dias_devendo_mkt <= 90);
    }
    if (this.deveDesde === 4) {
      item = item.filter((f) => f.dias_devendo_mkt >= 91);
    }

    if (this.c014Unidade > 0) {
      item = item.filter((f) => f.c014_id === this.c014Unidade);
    }

    const ids = _.map(this.statusCobranca, (item) => item.descricao);

    if (ids.length > 0) {
      return _.filter(item, (item) => {
        return ids.includes(item.status_cobranca);
      });
    } else {
      return item;
    }
  }

  // adimplentes
  get qtdDividaADP30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsAdimplentes) {
      this.allItemsAdimplentes.map((item) => {
        if (item.dias_devendo <= 30 && item.dias_devendo > 0) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaADP() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsAdimplentes) {
      this.allItemsAdimplentes.map((item) => {
        if (item.dias_devendo > 0) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaADP3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsAdimplentes) {
      this.allItemsAdimplentes.map((item) => {
        if (item.dias_devendo > 30 && item.dias_devendo <= 60) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaADP6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsAdimplentes) {
      this.allItemsAdimplentes.map((item) => {
        if (item.dias_devendo > 60 && item.dias_devendo <= 90) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaADP90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsAdimplentes) {
      this.allItemsAdimplentes.map((item) => {
        if (item.dias_devendo > 90) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  // geral
  get qtdDividaGeral30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsGeral) {
      this.allItemsGeral.map((item) => {
        if (item.dias_devendo <= 30 && item.dias_devendo > 0) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaGeral() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsGeral) {
      this.allItemsGeral.map((item) => {
        valor += _.toNumber(item.total);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaGeral3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsGeral) {
      this.allItemsGeral.map((item) => {
        if (item.dias_devendo > 30 && item.dias_devendo <= 60) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaGeral6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsGeral) {
      this.allItemsGeral.map((item) => {
        if (item.dias_devendo > 60 && item.dias_devendo <= 90) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaGeral90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsGeral) {
      this.allItemsGeral.map((item) => {
        if (item.dias_devendo > 90) {
          valor += _.toNumber(item.total);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  // livros
  get qtdDividaLivros30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivros) {
      this.allItemsLivros.map((item) => {
        if (item.dias_devendo_livro <= 30 && item.dias_devendo_livro > 0) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsLivros) {
      this.allItemsLivros.map((item) => {
        valor += _.toNumber(item.valor_atraso_livro);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivros) {
      this.allItemsLivros.map((item) => {
        if (item.dias_devendo_livro > 30 && item.dias_devendo_livro <= 60) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivros) {
      this.allItemsLivros.map((item) => {
        if (item.dias_devendo_livro > 60 && item.dias_devendo_livro <= 90) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsLivros) {
      this.allItemsLivros.map((item) => {
        if (item.dias_devendo_livro > 90) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaRenegociacao() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsRenegociacao) {
      this.allItemsRenegociacao.map((item) => {
        valor += _.toNumber(item.valor_atraso_reneg);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaRenegociacao30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsRenegociacao) {
      this.allItemsRenegociacao.map((item) => {
        if (item.dias_devendo_reneg <= 30 && item.dias_devendo_reneg > 0) {
          valor += _.toNumber(item.valor_atraso_reneg);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaRenegociacao3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsRenegociacao) {
      this.allItemsRenegociacao.map((item) => {
        if (item.dias_devendo_reneg > 30 && item.dias_devendo_reneg <= 60) {
          valor += _.toNumber(item.valor_atraso_reneg);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaRenegociacao6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsRenegociacao) {
      this.allItemsRenegociacao.map((item) => {
        if (item.dias_devendo_reneg > 60 && item.dias_devendo_reneg <= 90) {
          valor += _.toNumber(item.valor_atraso_reneg);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaRenegociacao90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsRenegociacao) {
      this.allItemsRenegociacao.map((item) => {
        if (item.dias_devendo_reneg > 90) {
          valor += _.toNumber(item.valor_atraso_reneg);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaTaxaFranquia30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsTaxaFranquia) {
      this.allItemsTaxaFranquia.map((item) => {
        if (item.dias_devendo_taxa_franquia <= 30 && item.dias_devendo_taxa_franquia > 0) {
          valor += _.toNumber(item.valor_atraso_taxa_franquia);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaTaxaFranquia() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsTaxaFranquia) {
      this.allItemsTaxaFranquia.map((item) => {
        valor += _.toNumber(item.valor_atraso_taxa_franquia);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaTaxaFranquia3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsTaxaFranquia) {
      this.allItemsTaxaFranquia.map((item) => {
        if (item.dias_devendo_taxa_franquia > 30 && item.dias_devendo_taxa_franquia <= 60) {
          valor += _.toNumber(item.valor_atraso_taxa_franquia);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaTaxaFranquia6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsTaxaFranquia) {
      this.allItemsTaxaFranquia.map((item) => {
        if (item.dias_devendo_taxa_franquia > 60 && item.dias_devendo_taxa_franquia <= 90) {
          valor += _.toNumber(item.valor_atraso_taxa_franquia);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaTaxaFranquia90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsTaxaFranquia) {
      this.allItemsTaxaFranquia.map((item) => {
        if (item.dias_devendo_taxa_franquia > 90) {
          valor += _.toNumber(item.valor_atraso_taxa_franquia);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMutuo30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMutuo) {
      this.allItemsMutuo.map((item) => {
        if (item.dias_devendo_mutuo <= 30 && item.dias_devendo_mutuo > 0) {
          valor += _.toNumber(item.valor_atraso_mutuo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMutuo() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsMutuo) {
      this.allItemsMutuo.map((item) => {
        valor += _.toNumber(item.valor_atraso_mutuo);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaMutuo3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMutuo) {
      this.allItemsMutuo.map((item) => {
        if (item.dias_devendo_mutuo > 30 && item.dias_devendo_mutuo <= 60) {
          valor += _.toNumber(item.valor_atraso_mutuo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMutuo6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMutuo) {
      this.allItemsMutuo.map((item) => {
        if (item.dias_devendo_mutuo > 60 && item.dias_devendo_mutuo <= 90) {
          valor += _.toNumber(item.valor_atraso_mutuo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMutuo90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsMutuo) {
      this.allItemsMutuo.map((item) => {
        if (item.dias_devendo_mutuo > 90) {
          valor += _.toNumber(item.valor_atraso_mutuo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaFundo() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsFundo) {
      this.allItemsFundo.map((item) => {
        valor += _.toNumber(item.valor_atraso_fundo);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaFundo30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsFundo) {
      this.allItemsFundo.map((item) => {
        if (item.dias_devendo_fundo <= 30 && item.dias_devendo_fundo > 0) {
          valor += _.toNumber(item.valor_atraso_fundo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaFundo3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsFundo) {
      this.allItemsFundo.map((item) => {
        if (item.dias_devendo_fundo > 30 && item.dias_devendo_fundo <= 60) {
          valor += _.toNumber(item.valor_atraso_fundo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaFundo6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsFundo) {
      this.allItemsFundo.map((item) => {
        if (item.dias_devendo_fundo > 60 && item.dias_devendo_fundo <= 90) {
          valor += _.toNumber(item.valor_atraso_fundo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaFundo90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsFundo) {
      this.allItemsFundo.map((item) => {
        if (item.dias_devendo_fundo > 90) {
          valor += _.toNumber(item.valor_atraso_fundo);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros30PF() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivrosVendaDireta) {
      this.allItemsLivrosVendaDireta.map((item) => {
        if (item.dias_devendo_livro <= 30 && item.dias_devendo_livro > 0) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivrosPF() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsLivrosVendaDireta) {
      this.allItemsLivrosVendaDireta.map((item) => {
        valor += _.toNumber(item.valor_atraso_livro);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros3060PF() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivrosVendaDireta) {
      this.allItemsLivrosVendaDireta.map((item) => {
        if (item.dias_devendo_livro > 30 && item.dias_devendo_livro <= 60) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros6090PF() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsLivrosVendaDireta) {
      this.allItemsLivrosVendaDireta.map((item) => {
        if (item.dias_devendo_livro > 60 && item.dias_devendo_livro <= 90) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaLivros90PF() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsLivrosVendaDireta) {
      this.allItemsLivrosVendaDireta.map((item) => {
        if (item.dias_devendo_livro > 90) {
          valor += _.toNumber(item.valor_atraso_livro);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMKT30() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMKT) {
      this.allItemsMKT.map((item) => {
        if (item.dias_devendo_mkt <= 30 && item.dias_devendo_mkt > 0) {
          valor += _.toNumber(item.valor_atraso_mkt);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMKT() {
    let contador = 0;
    let valor = 0;
    if (this.allItemsMKT) {
      this.allItemsMKT.map((item) => {
        valor += _.toNumber(item.valor_atraso_mkt);
        contador += 1;
      });
    }
    return [valor, contador];
  }

  get qtdDividaMKT3060() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMKT) {
      this.allItemsMKT.map((item) => {
        if (item.dias_devendo_mkt > 30 && item.dias_devendo_mkt <= 60) {
          valor += _.toNumber(item.valor_atraso_mkt);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMKT6090() {
    let valor = 0;
    let contador = 0;
    if (this.allItemsMKT) {
      this.allItemsMKT.map((item) => {
        if (item.dias_devendo_mkt > 60 && item.dias_devendo_mkt <= 90) {
          valor += _.toNumber(item.valor_atraso_mkt);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get qtdDividaMKT90() {
    let valor = 0;
    let contador = 0;

    if (this.allItemsMKT) {
      this.allItemsMKT.map((item) => {
        if (item.dias_devendo_mkt > 90) {
          valor += _.toNumber(item.valor_atraso_mkt);
          contador += 1;
        }
      });
    }
    return [valor, contador];
  }

  get VisualizarTitulosRecebidos() {
    return userActionStore.VisualizarTitulosRecebidos;
  }

  get ConsultarRelatorioOcorrencias() {
    return userActionStore.ConsultarRelatorioOcorrencias;
  }

  get ConsultarRetencaoUnidadesInativas() {
    return userActionStore.ConsultarRetencaoUnidadesInativas;
  }

  public async handleAddUnidade(item) {
    let form: any = null;
    this.itemUnidade = item;
    this.propId = 0;
    form = this.$refs.addUnidade;
    form.show();
  }

  public async handleEditUnidade(item) {
    let form: any = null;
    this.itemUnidade = item;
    this.propId = item.id_gestao;
    form = this.$refs.addUnidade;
    form.show();
  }

  public async handleListFinanceiroGeral(item: any) {
    this.tipoTitulo = [];
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroLivro(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 1,
      descricao: 'Livro',
    });
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroReneg(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 2,
      descricao: 'Renegociação',
    });
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroMutuo(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 3,
      descricao: 'Mutuo',
    });
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroFundo(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 4,
      descricao: 'Fundo',
    });
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroTaxaFranquia(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 5,
      descricao: 'Taxa de franquia',
    });
    this.handleFinanceiro(item);
  }

  public async handleListFinanceiroMKT(item: any) {
    this.tipoTitulo = [];
    this.tipoTitulo.push({
      id: 6,
      descricao: 'Reembolso',
    });
    this.handleFinanceiro(item);
  }

  public async handleFinanceiro(item: any) {
    let form: any = null;
    this.itemUnidade = item;
    this.propId = item.id;
    form = this.$refs.listFinanceiro;
    form.show();
  }

  public async handleSendSyngoo() {
    let form: any = null;
    form = this.$refs.listSyngoo;
    form.show();
  }

  public async handleListSyngoo() {
    let form: any = null;
    form = this.$refs.listSendSyngoo;
    form.show();
  }

  public async handleListTitulos() {
    let form: any = null;
    form = this.$refs.listTitulos;
    form.show();
  }

  public handleRelatorioOcorrencia() {
    let form: any = null;
    form = this.$refs.relOcorrencias;
    form.show();
  }

  public async handleUnidadesInativas() {
    this.isLoading = true;

    let tipo = this.tipoUnidade === 1 ? true : false;

    this.unidades_retencao = await retencaoFinanceiraStore.getRetencaoFinanceira(tipo);

    this.isLoading = false;
  }

  public async downloadExcelTotal(items, param, periodo, paramDiasDevendo) {
    let itemsExcel = this.filtroPorPeriodo(items, periodo, paramDiasDevendo);

    itemsExcel = this.filtroUnidadesToExcel(itemsExcel, param);

    try {
      // requisição POST para a rota do backend que gera o arquivo Excel

      const response = await api.getExcelUnidadeTotalPeriodo(mainStore.token, itemsExcel);
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Criando um elemento de link para simular o clique e iniciar o download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'totalperiodo.xlsx');
        document.body.appendChild(link);
        link.click();

        setTimeout(async () => {
          window.URL.revokeObjectURL(url);
        }, 100);
        // Liberando os recursos
      }
      // Criando um link para fazer o download do arquivo
    } catch (error) {
      await mainStore.checkApiError(<any>error);
    }
  }

  filtroUnidadesToExcel(items, param) {
    return _.map(items, (item) => {
      let total = 0;
      if (item[param]) {
        total = item[param];
      }
      return {
        unidade: item.unidade,
        cnpj: item.cnpj,
        total: total,
      };
    });
  }

  filtroPorPeriodo(items, periodo, param) {
    if (periodo === 1) {
      items = items.filter((f) => f[param] >= 1 && f[param] <= 30);
    }
    if (periodo === 2) {
      items = items.filter((f) => f[param] >= 31 && f[param] <= 60);
    }
    if (periodo === 3) {
      items = items.filter((f) => f[param] >= 61 && f[param] <= 90);
    }
    if (periodo === 4) {
      items = items.filter((f) => f[param] >= 91);
    }

    return items;
  }

  // public tempoEscola(item) {
  //   if (!this.currentUser) return 0;

  //   let desc_ano = "";
  //   let desc_mes = "";
  //   let tempo = "";

  //   if (item.data_inauguracao) {
  //     let created_at = item.data_inauguracao;

  //     let today = new Date().toISOString().split("T")[0];
  //     let totalMonths = differenceInMonths(
  //       new Date(today),
  //       new Date(created_at)
  //     );
  //     let years = Math.trunc(totalMonths / 12);
  //     let months = totalMonths % 12;

  //     if (years > 0) {
  //       desc_ano = years === 1 ? "ano" : "anos";
  //       if (years > 0 && months > 0) {
  //         desc_ano = years === 1 ? "ano" : "anos";
  //         desc_mes = months === 1 ? "mês" : "meses";
  //       }
  //       desc_mes = months === 0 ? "mês" : "meses";
  //       tempo = years + " " + desc_ano + " e " + months + " " + desc_mes;
  //       return tempo;
  //     } else {
  //       desc_mes = months === 0 ? "mês" : "meses";
  //       desc_mes = months === 1 ? "mês" : "meses";
  //       tempo = months + " " + desc_mes;
  //       return tempo;
  //     }
  //   } else {
  //     return "Não Inaugurada";
  //   }
  // }

  // public async handleSendBoletoSyngoo() {
  //   let res = await retencaoFinanceiraStore.enviaBoletoSyngooTresDias({
  //     t022: 57345,
  //     fone: "5547999570044",
  //   });
  // }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;

    this.unidades_retencao = await retencaoFinanceiraStore.getRetencaoFinanceira(true);

    this.isLoading = false;
  }
}
